<div *ngIf="muro && !muro.borrada && muro.novisible == ''" [class.blur-strong]="misdatos.perfilPublico == 'no_publico'">
  <div id="muro{{muro.rs_id}}" [ngClass]="{'iguau-post-card' : muro.nivel == 0}">
    <app-muro-perfil [misdatos]="misdatos" [perfil]="perfil" [muro]="muro"></app-muro-perfil>
    <div *ngIf="!muro.showeditar">
      <!--PASEO-->
      <div class="row walk-details mb-3" aria-label="Detalles del paseo" *ngIf="muro.rs_tipo_publicacion == '01'">
        <div class="col-12">
          <div class="ig-walk-state" [class.ig-walk-state--past]="$any(muro).paseo_finalizado">
            <i class="fa-solid" [ngClass]="$any(muro).paseo_finalizado ? 'fa-circle-check' : 'fa-calendar-check'" aria-hidden="true"></i>
            {{ $any(muro).paseo_finalizado ? 'Paseo finalizado' : 'Próximo paseo' }}
          </div>
          <strong><app-leer-mas [texto]="muro.rs_texto" [limite]="300"></app-leer-mas></strong>
          <p *ngIf="$any(muro).paseo_finalizado" class="ig-walk-memory-hint"><i class="fa-regular fa-images"></i> El encuentro ya pasó. Puedes seguir comentando y compartiendo recuerdos.</p>
        </div>
        <div class="col-auto text-uppercase">
          <div>Fecha</div>
          <strong>{{ muro.paseo!.rsp_fecha + 'T' + muro.paseo!.rsp_hora | relativeDate }} {{ muro.paseo!.rsp_fecha | smartDate }}</strong>
        </div>
        <div class="col-auto text-uppercase">
          <div>Hora</div>
          <strong>{{ muro.paseo!.rsp_hora | formatoHora }}</strong>
        </div>
        <div class="col text-uppercase">
          <div>Ubicación</div>
          <strong>{{ muro.paseo!.rsp_ubicacion }}</strong>
        </div>
        <div class="col-auto text-center text-uppercase">
          <div>Participantes</div>
          <strong>{{ muro.rs_participantes_paseo }}</strong>
        </div>
      </div>
      <!--SERVICIO-->
      <div class="row service-details mb-3" aria-label="Detalles del servicio" *ngIf="muro.rs_tipo_publicacion == '02'">
        <div class="col-12">
          <strong><app-leer-mas [texto]="muro.rs_texto" [limite]="300"></app-leer-mas></strong>
        </div>
        <div class="col-auto text-uppercase">
          <div>Tipo de servicio</div>
          <strong>{{ muro.servicio!.va_nombre }}</strong>
        </div>
        <div class="col-auto text-uppercase">
          <div>Objetivo</div>
          <strong *ngIf="muro.servicio!.rsse_rol == '1'">Ofrezco</strong>
          <strong *ngIf="muro.servicio!.rsse_rol == '2'">Necesito</strong>
        </div>
      </div>
      <!-- ENCUESTA: opciones y resultados integrados en una tarjeta compacta -->
      <section class="ig-poll mb-3" aria-label="Encuesta" *ngIf="muro.rs_tipo_publicacion == '03'">
        <div class="ig-poll-intro" *ngIf="muro.rs_texto">
          <app-leer-mas [texto]="muro.rs_texto" [limite]="230"></app-leer-mas>
        </div>
        <div class="ig-poll-question" *ngFor="let pregunta of muro.encuesta">
          <div class="ig-poll-heading">
            <div class="ig-poll-title"><i class="fa-solid fa-chart-simple" aria-hidden="true"></i><strong>{{ pregunta.rse_pregunta }}</strong></div>
            <span class="ig-poll-votes">{{ pregunta.totalVotos || 0 }} {{ pregunta.totalVotos == 1 ? 'voto' : 'votos' }}</span>
          </div>
          <div class="ig-poll-options" [attr.aria-label]="pregunta.rse_pregunta">
            <ng-container *ngIf="pregunta.rse_tipo == '01'">
              <ng-container *ngFor="let opcion of ['Sí','No']">
                <button type="button" class="ig-poll-option"
                  [class.ig-poll-option--selected]="pregunta.rser_respuesta == opcion"
                  [disabled]="pregunta.busy"
                  [attr.aria-pressed]="pregunta.rser_respuesta == opcion"
                  (click)="respondeEncuesta(pregunta, opcion)">
                  <span class="ig-poll-fill" [style.width.%]="getPorcentaje(pregunta, opcion)"></span>
                  <span class="ig-poll-option-text"><i *ngIf="pregunta.rser_respuesta == opcion" class="fa-solid fa-circle-check" aria-hidden="true"></i>{{ opcion }}</span>
                  <span class="ig-poll-percent">{{ getPorcentaje(pregunta, opcion) }}%</span>
                </button>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="pregunta.rse_tipo == '02'">
              <ng-container *ngFor="let i of [1,2,3,4]">
                <ng-container *ngIf="getRespuestaTexto(pregunta, i) as opcion">
                  <button type="button" class="ig-poll-option"
                    [class.ig-poll-option--selected]="pregunta.rser_respuesta == opcion"
                    [disabled]="pregunta.busy"
                    [attr.aria-pressed]="pregunta.rser_respuesta == opcion"
                    (click)="respondeEncuesta(pregunta, opcion)">
                    <span class="ig-poll-fill" [style.width.%]="getPorcentaje(pregunta, opcion)"></span>
                    <span class="ig-poll-option-text"><i *ngIf="pregunta.rser_respuesta == opcion" class="fa-solid fa-circle-check" aria-hidden="true"></i>{{ opcion }}</span>
                    <span class="ig-poll-percent">{{ getPorcentaje(pregunta, opcion) }}%</span>
                  </button>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
          <div class="ig-poll-foot">
            <span *ngIf="pregunta.rser_respuesta"><i class="fa-solid fa-check" aria-hidden="true"></i> Has votado · Pulsa tu opción para retirar el voto</span>
            <span *ngIf="!pregunta.rser_respuesta">Selecciona una opción para votar</span>
            <span *ngIf="pregunta.busy" role="status"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span> Guardando…</span>
          </div>
        </div>
      </section>
      <!--TEXTO-->
      <div class="mt-3 mb-3" *ngIf="muro.rs_tipo_publicacion == ''">
        <app-leer-mas [texto]="muro.rs_texto" [limite]="300"></app-leer-mas>
      </div>
      <div class="w-100 mt-2 mb-3" *ngIf="muro.rs_fotos?.length > 0">
          <app-carousel [class.disabled-div]="misdatos.rol == 'no_publico'"
            [images]="getCarouselImages(muro)"
            [visibleCount]="3"></app-carousel>
      </div>
      <div *ngIf="!muro.rs_fotos" class="mt-3">
        <span class="spinner-border spinner-border-sm text-iguau" aria-hidden="true"></span>
        <span class="text-secondary ms-1">Cargando... </span>
      </div>
    </div>

    <app-muro-acciones [misdatos]="misdatos" [perfil]="perfil" [muro]="muro" (abrirConversacion)="solicitarResponder(muro)"></app-muro-acciones>
    <div *ngIf="modalComentarios && muro.nivel === 0" class="ig-comments-backdrop" (click)="cerrarComentarios()">
      <section class="ig-comments-dialog" role="dialog" aria-modal="true" [attr.aria-label]="'Comentarios de ' + muro.first_name" (click)="$event.stopPropagation()">
        <div class="ig-comments-visual" *ngIf="muro.rs_fotos?.length">
          <div class="ig-photo-frame"><img [src]="muro.rs_fotos[fotoActual]?.foto_grande" alt="Imagen de la publicación" /></div>
          <div class="ig-photo-nav" *ngIf="muro.rs_fotos.length > 1">
            <button type="button" (click)="cambiarFoto(-1)" aria-label="Foto anterior"><i class="fa-solid fa-chevron-left"></i></button>
            <span>{{fotoActual + 1}} / {{muro.rs_fotos.length}}</span>
            <button type="button" (click)="cambiarFoto(1)" aria-label="Foto siguiente"><i class="fa-solid fa-chevron-right"></i></button>
          </div>
        </div>
        <div class="ig-comments-right">
          <header class="ig-comments-head">
            <img [src]="muro.foto_principal_thumb" alt="" />
            <div><strong>{{muro.first_name}}</strong><span>Conversación</span></div>
            <button type="button" class="ig-close" (click)="cerrarComentarios()" aria-label="Cerrar comentarios"><i class="fa-solid fa-xmark"></i></button>
          </header>
          <div class="ig-comments-scroller">
            <div class="ig-original-text" *ngIf="muro.rs_texto"><app-leer-mas [texto]="muro.rs_texto" [limite]="500"></app-leer-mas></div>
            <div class="ig-empty-comments" *ngIf="!muro.comentarios?.length">Sé el primero en responder.</div>
            <app-muro *ngFor="let comentario of muro.comentarios" [muro]="comentario" [perfil]="perfil" [misdatos]="misdatos" (responderA)="propagarRespuesta($event)"></app-muro>
            <button type="button" class="ig-more-comments" *ngIf="muro.numcomentarios > 0 && !muro.noMasComentarios" (click)="masComentarios()" [disabled]="muro.loadingComentarios">{{muro.loadingComentarios ? 'Cargando…' : 'Ver más comentarios (' + muro.numcomentarios + ')'}}</button>
          </div>
          <form class="ig-comment-bottom" (ngSubmit)="publicarComentario()">
            <div class="ig-reply-target" *ngIf="respondiendoA"><span>Respondiendo a <strong>{{respondiendoA.first_name}}</strong></span><button type="button" (click)="cancelarRespuesta()" aria-label="Cancelar respuesta"><i class="fa-solid fa-xmark"></i></button></div>
            <div class="ig-comment-photos" *ngIf="fotosComentario.length">
              <div class="ig-comment-photo" *ngFor="let foto of fotosComentario; let i = index">
                <img [src]="foto.preview" alt="Foto adjunta" />
                <button type="button" (click)="quitarFotoComentario(i)" [disabled]="enviandoComentario" [attr.aria-label]="'Quitar foto ' + (i + 1)"><i class="fa-solid fa-xmark"></i></button>
              </div>
            </div>
            <div class="ig-comment-error" *ngIf="errorComentario" role="alert">{{errorComentario}}</div>
            <div class="ig-comment-compose">
              <input #comentarioFotosInput type="file" accept="image/*" multiple hidden (change)="seleccionarFotosComentario($event)" />
              <button type="button" class="ig-comment-attach" (click)="comentarioFotosInput.click()" [disabled]="enviandoComentario || fotosComentario.length >= 5" title="Añadir fotos" aria-label="Adjuntar fotos"><i class="fa-regular fa-image"></i></button>
              <textarea #comentarioTextarea name="comentario" [(ngModel)]="nuevoComentario" rows="2" maxlength="1500" [disabled]="enviandoComentario" [placeholder]="respondiendoA ? 'Escribe una respuesta…' : 'Escribe un comentario…'" aria-label="Escribe un comentario"></textarea>
              <button type="submit" [disabled]="(!nuevoComentario.trim() && !fotosComentario.length) || enviandoComentario" aria-label="Publicar comentario"><i class="fa-solid fa-paper-plane"></i></button>
            </div>
          </form>
        </div>
      </section>
    </div>


    <div class="ig-nested-replies" *ngIf="muro.nivel > 0 && muro.comentarios?.length > 0">
      <app-muro *ngFor="let comentario of muro.comentarios"
                [muro]="comentario"
                [perfil]="perfil"
                [misdatos]="misdatos" (responderA)="propagarRespuesta($event)">
      </app-muro>
    </div>
    <!--MAS COMENTARIOS-->
    <div class="row small ms-3" *ngIf="muro.nivel > 0 && muro.numcomentarios > 0 && !muro.noMasComentarios">
      <div class="col-auto custom-link text-iguau" (click)="masComentarios()">
        <span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="muro.loadingComentarios"></span>
        {{muro.numcomentarios > 1 ? 'Ver 2 comentarios más' : 'Ver 1 comentario más'}}
      </div>
    </div>
  </div>
</div>